import { render, staticRenderFns } from "./FinalRoundSettings.vue?vue&type=template&id=4227cef8&scoped=true"
import script from "./FinalRoundSettings.vue?vue&type=script&lang=js"
export * from "./FinalRoundSettings.vue?vue&type=script&lang=js"
import style0 from "./FinalRoundSettings.vue?vue&type=style&index=0&id=4227cef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227cef8",
  null
  
)

export default component.exports